<template>
  <b-card>
    <b-row>
      <b-col
        cols="4"
      >
        <div class="w-100">
          <legend class="col-form-label pt-0">
            Data do log
          </legend>
          <de-para
            v-model="servidorParams.filtros.data"
          />
        </div>
      </b-col>
      <b-col
        cols="4"
      >
        <legend class="col-form-label pt-0">
          Módulo
        </legend>
        <v-select
          v-model="servidorParams.filtros.modulo"
          :options="[{ descricao: '', numero: 0 }, { descricao: 'Cobrança', numero: 1 }, { descricao: 'Comercial', numero: 2 }, { descricao: 'Compartilhado', numero: 3 }]"
          label="descricao"
          :clearable="false"
        >
          <template v-slot:option="option">
            {{ option.descricao }}
          </template>
        </v-select>
      </b-col>
      <b-col cols="auto">
        <legend class="col-form-label pt-0">
          &nbsp;
        </legend>
        <div style="padding-top:6.218px">
          <div
            style="display: inline-block;"
            tabindex="0"
            class="linha-vertical"
          >
            <b-btn
              id="popover-filtro-log"
              variant="none"
              class="btn-primary btn-sm mr-50"
            >
              <feather-icon
                style="margin-right:0.25rem"
                icon="FilterIcon"
              />Filtros</b-btn>
          </div>
          <div style="display: contents;">
            <b-btn
              variant="none"
              class="btn-primary btn-sm mr-50 ml-50"
              @click.prevent.stop="limpar()"
            >Limpar</b-btn>
            <b-btn
              variant="none"
              class="btn-primary btn-sm"
              @click="aplicar()"
            >Aplicar</b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
    <hr
      class="mx-0 mt-0 my-2"
      style="border-top: 1px solid #a3a4a66b !important;"
    >
    <b-row>
      <b-col cols="12">
        <vue-good-table
          ref="tabelaLogs"
          :columns="colunas"
          :rows="dadosTabela"
          row-style-class="clickable"
          theme="view"
          :total-rows="totalLinhas"
          :is-loading.sync="isCarregando"
          :pagination-options="{
            enabled: true,
            perPage: 10,
          }"
          @on-cell-click="visualizarRelatorio"
          @on-page-change="onAlterarPagina"
          @on-sort-change="onAlterarOrdenacao"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span v-if="props.column.field === 'descricaoRegistro' && props.row.empresa">
              <div class="tag-cadastro-federal">
                <span style="margin-right: 0.2rem;">
                  {{ props.row.cadastroFederal }}
                </span>
              </div>
              {{ props.row.razaoSocial }}
            </span>
          </template>
          <!-- no records -->
          <div slot="emptystate">
            <p style="text-align:center; margin:0">
              Nenhum registro encontrado.
            </p>
          </div>
          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <paginacao-base
              :valor="props"
              :quantidade="10"
            />
          </template>
        </vue-good-table>
      </b-col>
    </b-row>
    <visualizacao-relatorio
      ref="visualizacaoRelatorio"
      :info="info"
      :relatorio="relatorio"
      @close="onCloseRelatorio"
    />
    <filtro-adicional :value="servidorParams.filtros" />
  </b-card>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.tag-cadastro-federal {
  & span {
    font-size: 0.65rem;
    color: #ab9b1a;
    font-weight: 700;
    background-color: transparent;
    border: 1px solid #ab9b1a !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'TabelaLog',
  components: {
    VueGoodTable,
    vSelect,
    DePara: () => import('@/shared/components/de-para/DePara.vue'),
    FiltroAdicional: () => import('@/app-modulo/comuns/log/shared/components/filtro-adicional/FiltroAdicional.vue'),
    VisualizacaoRelatorio: () => import('@/app-modulo/comuns/log/shared/components/visualizacao-relatorio/VisualizacaoRelatorio.vue'),
    PaginacaoBase: () => import('@/shared/components/paginacao-base/PaginacaoBase.vue'),
  },
  props: {
    colunas: {
      type: Array,
      required: true,
    },
    carregar: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isCarregando: false,
      dadosTabela: [],
      totalLinhas: 0,
      servidorParams: {
        filtros: {
          data: {},
          modulo: '',
          ordemBy: [
            {
              coluna: '',
              tipo: '',
            },
          ],
        },
        page: 1,
        perPage: 10,
      },
      info: {},
      relatorio: {},
      linhaSelecionada: null,
    }
  },
  created() {
    this.servidorParams.filtros.data.dataInicio = new Date(Date.now())
    this.servidorParams.filtros.data.dataFim = new Date(Date.now())
    this.servidorParams.filtros.modulo = { descricao: 'Cobrança', numero: 1 }
    this.servidorParams.filtros.ordemBy = [{ coluna: 'inicio', tipo: 'desc' }]
    this.montarGrid()
  },
  methods: {
    visualizarRelatorio(params) {
      if (this.linhaSelecionada !== params.rowIndex) {
        this.info = params.row
        this.linhaSelecionada = params.rowIndex
        if (this.info.relatorio) {
          this.$refs.visualizacaoRelatorio.$refs.modalRelatorio.show()
          this.relatorio = JSON.parse(this.info.relatorio, (_key, value) => (value == null ? '' : value))
        }
      }
    },
    aplicar() {
      this.montarGrid()
    },
    limpar() {
      this.servidorParams.filtros = {
        data: {},
        modulo: '',
        empresas: null,
        usuarios: null,
        telas: null,
        eventos: null,
        processos: null,
      }
    },
    montarGrid() {
      this.isCarregando = true
      this.carregar(this.servidorParams.page, this.servidorParams.perPage, this.servidorParams.filtros)
        .then(payload => {
          this.servidorParams.page = payload.data.currentPage || 1
          this.totalLinhas = payload.data.rowCount
          this.dadosTabela = payload.data.queryable
          this.isCarregando = false
        })
        .catch(() => {
          this.isCarregando = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Não foi possível carregar as informações',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
        })
    },
    updateParams(newProps) {
      this.servidorParams = { ...this.servidorParams, ...newProps }
    },
    onAlterarPagina(params) {
      this.updateParams({ page: params.currentPage })
      this.montarGrid()
    },
    onAlterarOrdenacao(params) {
      this.servidorParams.filtros.ordemBy = [
        { tipo: params[0].type, coluna: params[0].field },
      ]
      this.montarGrid()
    },
    onCloseRelatorio() {
      this.linhaSelecionada = null
    },
  },
}
</script>
